import { render } from "./CustomMenuAccordion.vue?vue&type=template&id=2e8c15b4"
import script from "./CustomMenuAccordion.vue?vue&type=script&lang=js"
export * from "./CustomMenuAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__